import './index.scss';
import React from 'react';
import _ from 'lodash';
import qs from 'qs';
import ListGroup from 'react-bootstrap/ListGroup';
import { BsQuestionCircleFill as UnknownIcon } from 'react-icons/bs';
import { Link, useLocation } from 'react-router-dom';

import { ReactComponent as NewRelicIcon } from 'icons/NewRelic.svg';
import { ReactComponent as StackdriverIcon } from 'icons/stackdriver.svg';
import { ReactComponent as CloudwatchIcon } from 'icons/aws-cloudwatch.svg';
import { ReactComponent as AWSIcon } from 'icons/aws.svg';
import { ReactComponent as DatadogIcon } from 'icons/dd_logo_v_rgb.svg';
import { ReactComponent as AzureIcon } from 'icons/azure.svg';
import { ReactComponent as KubernetesIcon } from 'icons/kubernetes.svg';
import { ReactComponent as RackspaceIcon } from 'icons/rackspace-r.svg';
import { ReactComponent as VMWareIcon } from 'icons/vmware_logo.svg';
import { translations } from '@janus.team/janus-particles';
import { useWebhooksForAccountQuery } from 'api/watchman';
import { useCurrentAccount } from 'account-selector';

const useDataSources = () => {
  const { tenantId } = useCurrentAccount() || {};
  const latestWebhooks = useWebhooksForAccountQuery(tenantId)?.data;
  const dataSources = _.filter(_.uniqBy(latestWebhooks, 'type'), { enabled: true });
  return dataSources;
};

const IconOf = ({ id, label }) => {
  const t = translations.useT();
  const IconComponent = _.get({
    NEW_RELIC: NewRelicIcon,
    DATADOG: DatadogIcon,
    CLOUDWATCH: CloudwatchIcon,
    STACKDRIVER: StackdriverIcon,
    AZURE: AzureIcon,
    AZURE_APPLICATION_INSIGHTS: AzureIcon,
    AZURE_LOG_ANALYTICS: AzureIcon,
    AZURE_V_MWARE_V_CENTER: AzureIcon,
    AZURE_METRIC_ALERTS: AzureIcon,
    ALERT_MANAGER: KubernetesIcon,
    BACKUP: AWSIcon,
    MAINTENANCE_WINDOW: RackspaceIcon,
    RDS: AWSIcon,
    SSM: AWSIcon,
    APS: RackspaceIcon,
    EVENT_BRIDGE: AWSIcon,
    V_MWARE_V_CENTER: VMWareIcon
  }, _.toUpper(_.snakeCase(id)), UnknownIcon);
  return <IconComponent title={t(label)} />;
};

export const useCurrentDataSource = () => {
  const dataSources = useDataSources();
  const parsedQuery = qs.parse(useLocation()?.search || '', { ignoreQueryPrefix: true }) || {};
  const { dataSource } = parsedQuery || {};
  return _.find(dataSources, { type: dataSource, enabled: true });
};

export const DataSourceSelector = () => {
  const dataSources = useDataSources();
  const { pathname } = useLocation();
  const t = translations.useT();
  const search = qs.parse(useLocation()?.search || '', { ignoreQueryPrefix: true });
  return (
    <div className="data-source-selector container-xxl container-fluid mb-10">
      <h2 className="my-6">Monitoring Services</h2>
      <ListGroup className="data-source-selection">
        {_.map(dataSources, (dataSourceItem) => {
          const selected = dataSourceItem.enabled && (search?.dataSource === dataSourceItem?.name);
          const id = `select-data-source-${dataSourceItem?.name}`;
          const toSearch = qs.stringify(_.merge({}, search, { dataSource: dataSourceItem?.name }));
          return (
            <ListGroup.Item
              id={id}
              key={id}
              action
              active={selected}
              className="cursor-pointer py-lg-10"
              as={Link}
              disabled={!dataSourceItem.enabled}
              to={{ pathname, search: toSearch }}
              tabIndex="0"
            >
              <div className="d-flex flex-lg-column gap-4 align-items-center">
                <IconOf id={dataSourceItem?.name} label={dataSourceItem?.name} />
                <span className="mt-lg-4">{t(dataSourceItem?.name)}</span>
              </div>
            </ListGroup.Item>
          );
        })}
      </ListGroup>
    </div>
  );
};